import type { SVGProps } from 'react'
const IconBuildingOffice2Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.97 19.43a.75.75 0 0 1 .75-.75h18a.75.75 0 0 1 0 1.5h-18a.75.75 0 0 1-.75-.75M8.988 11.328a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-1.5 0v-.01a.75.75 0 0 1 .75-.75M8.988 8.004a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-1.5 0v-.01a.75.75 0 0 1 .75-.75M16.769 15.39a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-1.5 0v-.01a.75.75 0 0 1 .75-.75M16.769 12.438a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-1.5 0v-.01a.75.75 0 0 1 .75-.75"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.805 8.27c1.33-.14 2.49.9 2.49 2.239v8.918a.75.75 0 0 1-1.5 0V10.51a.75.75 0 0 0-.83-.747l-5.895.632a.75.75 0 0 1-.16-1.492zM8.988 15.477a.75.75 0 0 1 .75.75v3.202a.75.75 0 0 1-1.5 0v-3.202a.75.75 0 0 1 .75-.75"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.246 6.07a2.25 2.25 0 0 1 2.478-2.238l4.982.505a2.25 2.25 0 0 1 2.024 2.239v2.139q.01.061.01.125v10.59a.75.75 0 0 1-.76.75.75.75 0 0 1-.75-.75V6.576a.75.75 0 0 0-.674-.747l-4.983-.505a.75.75 0 0 0-.827.747V19.43a.75.75 0 0 1-1.5 0z"
      clipRule="evenodd"
    />
  </svg>
)
export default IconBuildingOffice2Icon
